import type * as React from "react";
import { cn } from "../../lib/utils";

/**
 * Pole tekstowe.
 *
 * `aria-invalid` zmienia obrys i pierścień, więc walidacja jest widoczna bez
 * dokładania klas w miejscu użycia — a stan błędu nie zależy wtedy od tego, czy
 * ktoś pamiętał o dopisaniu koloru.
 */
export function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "focus-ring-own flex h-9 w-full min-w-0 rounded-md border border-input bg-secondary/40 px-3 py-1",
        "text-sm text-foreground shadow-sm transition-[color,box-shadow,border-color] outline-none",
        "placeholder:text-muted-foreground/70",
        "focus-visible:border-ring focus-visible:ring-[0.1875rem] focus-visible:ring-ring/50",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "aria-invalid:border-destructive aria-invalid:ring-destructive/30",
        "file:mr-2 file:border-0 file:bg-transparent file:text-sm file:font-medium",
        className,
      )}
      {...props}
    />
  );
}

export function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "focus-ring-own flex min-h-16 w-full rounded-md border border-input bg-secondary/40 px-3 py-2",
        "text-sm text-foreground shadow-sm transition-[color,box-shadow,border-color] outline-none",
        "placeholder:text-muted-foreground/70 field-sizing-content",
        "focus-visible:border-ring focus-visible:ring-[0.1875rem] focus-visible:ring-ring/50",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}
